import createIcon from '../../createIcon';

/**
 * @component @name History
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNSAzQzguNTMgMyA0LjUgNy4wMyA0LjUgMTJIMS41TDUuMzkgMTUuODlMNS40NiAxNi4wM0w5LjUgMTJINi41QzYuNSA4LjEzIDkuNjMgNSAxMy41IDVDMTcuMzcgNSAyMC41IDguMTMgMjAuNSAxMkMyMC41IDE1Ljg3IDE3LjM3IDE5IDEzLjUgMTlDMTEuNTcgMTkgOS44MiAxOC4yMSA4LjU2IDE2Ljk0TDcuMTQgMTguMzZDOC43NyAxOS45OSAxMS4wMSAyMSAxMy41IDIxQzE4LjQ3IDIxIDIyLjUgMTYuOTcgMjIuNSAxMkMyMi41IDcuMDMgMTguNDcgMyAxMy41IDNaTTEyLjUgOFYxM0wxNi43OCAxNS41NEwxNy41IDE0LjMzTDE0IDEyLjI1VjhIMTIuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const History = createIcon('History', [
  [
    'path',
    {
      d: 'M13.5 3C8.53 3 4.5 7.03 4.5 12H1.5L5.39 15.89L5.46 16.03L9.5 12H6.5C6.5 8.13 9.63 5 13.5 5C17.37 5 20.5 8.13 20.5 12C20.5 15.87 17.37 19 13.5 19C11.57 19 9.82 18.21 8.56 16.94L7.14 18.36C8.77 19.99 11.01 21 13.5 21C18.47 21 22.5 16.97 22.5 12C22.5 7.03 18.47 3 13.5 3ZM12.5 8V13L16.78 15.54L17.5 14.33L14 12.25V8H12.5Z',
      key: '123dtm',
    },
  ],
]);

export default History;
